//const API = "http://192.168.2.19:8080/";
//  http://192.168.2.71:3000/login
const API = "https://epaperroadapi.ferndaleroad.com/epaper-road-prod/";
//const API =   "https://epaperroadapi.colan.in/epaper-road/"

const configUrl = {
  common: {
    LOGIN: `${API}oauth/token`,
    PROFILE: `${API}API/epaper/profile/`,
    EDITPROFILE: `${API}API/epaper/profile/editprofile`,
    EDITADMINPROFILE: `${API}API/epaper/employee/update`,
    CHANGEPASSWORD: `${API}users/changepassword`,
    FORGOTPASSWORD: `${API}API/register/forgotpassword`,
    NEWPASSWORD: `${API}API/register/checkrandompwd`,
    GET_NPI_DATA: `${API}API/npi/get`,
    EMAIL_VALID: `${API}API/register/validate/email`,
    MOBILE_VALID: `${API}API/register/validate/mobile`,
    CONTACTSERVICEURL: `${API}API/register/contact`,
    VIEWREQUESTINFO: `${API}API/epaper/employees/request/view`,
    VERIFY_REGISTER: `${API}API/register/userregister/activate`,
    TERMS_EMAIL: `${API}API/register/add/siterules/attachment`,
    RESEND_VERIFY_EMAIL: `${API}API/register/resendVerificationLink`,
    UPDATE_NOTE : `${API}API/epaper/employee/addorupdate/notes`
  },

  patient: {
    PATIENT_REGISTER: `${API}API/register/patient`,
    NEW_FACILITY_REQUEST: `${API}API/epaper/patientrequest/facility`,
    PATIENT_REQUEST_INFO: `${API}API/epaper/request/get/patient/requestInfo/`,
    GET_BY_PRACTICE: `${API}API/epaper/search/byFacility`,
    GET_BY_DOCTOR: `${API}API/epaper/search/byPractioner`,
    GET_BY_LOCATION: `${API}API/register/byLocationInRegister`,
    SEARCH_BY_ALL: `${API}API/epaper/search/finalSearchResult`,
    GET_RECORDS_LIST: `${API}API/epaper/records/listRecordsType`,
    GET_RESPONSE_TIME_LIST: `${API}API/epaper/records/listResponseTime`,
    GET_AUTH_EXP_LIST: `${API}API/epaper/records/listDocumentExpiration`,
    GET_FACILITY_ADDRESS: `${API}API/epaper/records/getFacilityAddress/`,
    GET_APP_COST: `${API}API/epaper/records/approximateCost`,
    ADD_PAYMENT_METHOD: `${API}API/epaper/fattmerchant/add/paymentmethod`,
    GET_PAYMENT_METHODS: `${API}API/epaper/fattmerchant/get/allpayment/`,
    DELETE_PAYMENT_METHOD: `${API}API/epaper/fattmerchant/delete/customer/`,
    COST_AGREE: `${API}API/epaper/records/request/update`,
    IS_AUTO_PAY: `${API}API/epaper/records/request/finalize`,
    IS_DEFAULT_CARD: `${API}API/epaper/fattmerchant/update/isdefault`,
    CHARGE_FINAL_COST: ` ${API}API/epaper/records/patient/charge`,
    DOWNLOAD_RECORDS: ` ${API}API/epaper/records/downloadFile`,
    VALIDATE_FEDEX_AVAIL: `${API}API/epaper/fedex/check/availability`,
    GET_OTHER_CLASSIFICATIONS: `${API}API/epaper/records/listThirdPartyClassification`,
    DISABLE_ACCOUNT: `${API}API/epaper/patient/disable/account`,
    ENABLE_ACCOUNT: `${API}API/epaper/patient/enable/request/otp`,
    VERIFY_OTP_ENABLE_ACCOUNT: `${API}API/epaper/patient/enable/validate/otp`
  },

  facility: {
    FACILITY_REGISTER: `${API}API/register/facility`,
    FACILITY_REGISTER_OTP: `${API}API/register/sendotp`,
    FACILITY_REGISTER_CONFIRM_OTP: `${API}API/register/otpverification`,
    ADD_PRACTITIONERS: `${API}API/epaper/practioner/add`,
    GET_PRACTITIONERS_LIST: `${API}API/epaper/practioner/getpractitioner/forfacility/`,
    EDIT_PRACTITIONER: `${API}API/epaper/practioner/update`,
    DELETE_PRACTITIONER: `${API}API/epaper/practioner/delete/`,
    GET_CLOUD_BASE_EMR_VPN: `${API}API/epaper/setup/get/emr/`,
    SAVE_CLOUD_BASE_EMR: `${API}API/epaper/setup/emr/save`,
    GET_REMOTE_ACCESS_VPN: `${API}API/epaper/setup/get/vpn/`,
    SAVE_REMOTE_VPN: `${API}API/epaper/setup/vpn/save`,
    EMAIL_BAA_DOC: `${API}API/register/add/attachment`,
    REQUEST_INFO_LIST: `${API}API/epaper/facility/get/facility/requestInfo/`,
    VERIFY_SERVICE: `${API}API/epaper/fedex/verify/service`,
    FACILITY_SELECT_TYPE: `${API}API/epaper/facility/otherrquestor/classification/list`,
    FACILITY_CREATE_UPDATE_SELECTED: `${API}API/epaper/facility/create/otherrquestor/classification`,
    APPROVE_STATUS: `${API}API/epaper/facility/approve`,
    DECLINE_STATUS: `${API}API/epaper/search/facilityDenied`
  },

  admin: {
    GET_EMPLOYE_LIST: `${API}API/epaper/employee/get`,
    ADD_EMPLOYE: `${API}API/epaper/employee/add`,
    EDIT_EMPLOYE: `${API}API/epaper/employee/update`,
    DELETE_EMPLOYE: `${API}API/epaper/employee/delete/`,
    GET_PAYMENT_RULES: `${API}API/epaper/employee/get/payment/rules`,
    EDIT_PAYMENT_RULE: `${API}API/epaper/employee/update/payment/rules`,
    GET_APPROXIMATE_COST: `${API}API/epaper/approximatecost/pages`,
    UPDATE_APPROXIMATE_COST: `${API}API/epaper/approximatecost/pages/update`,
    GET_BESTPERFORMANCE_LIST: `${API}API/epaper/employees/performance?`,
    GET_REQUEST_STATUS_LIST: `${API}API/epaper/request/list/byStatus`,
    REVENUE_REPORTS: `${API}API/epaper/reports/revenue`,
    FAXED_PAGES_API: `${API}API/epaper/reports/fax/pages`,
    AVERAGE_REPORTS: `${API}API/epaper/reports/record/pages`,
    FACILITY_REPORTS: `${API}API/epaper/reports/facility`,
    COMPLETED_REPORTS: `${API}API/epaper/reports/records/status`,
    PRACTITIONER_REPORTS: `${API}API/epaper/reports/practitioner`,
    GET_HEDIS_FLAT: `${API}API/epaper/hedisflat/get`,
    UPDATE_HEDIS_FLAT: `${API}API/epaper/hedisflat/update`,
    DELETE_UNPROCESSED_REQUEST: `${API}API/epaper/employee/patient/records/delete/`,
    GET_MONTHLY_REQUEST_LIST: `${API}API/epaper/reports/admin/monthWise/report`,
    DELETE_REQUESTED_PRACTICE: `${API}API/epaper/patientrequest/delete/`,
    ADMIN_EDIT_COST_DETAILS: `${API}API/epaper/records/request/adminEdit`
  },

  employee: {
    GET_FACILITY_LIST: `${API}API/epaper/facility/facilitylist/all`,
    GET_NEW_FACILITY_LIST: `${API}API/epaper/patientrequest/requestlist`,
    GET_VIEW_DETAILS: `${API}API/epaper/facility/viewfacilitydetails/`,
    FACILITY_REG_STATUS_CHANGE: `${API}API/epaper/facility/updatefacility/status`,
    FACILITY_REQUEST_STATUS_CHANGE: `${API}API/epaper/employee/updatestatus`,
    RECORD_REQ_LIST: `${API}API/epaper/employee/get/employee/requestInfoList`,
    FINAL_COST: `${API}API/epaper/records/finalCost`,
    ASSIGN_EMPLOYEE_STATUS: `${API}API/epaper/employees/request/update/employeeStatus`,
    FEDEX_TRACKING: `${API}API/epaper/fedex/get/notification`,
    CHECK_FAXSTATUS: `${API}API/epaper/check/faxstatus`,
    DOWNLOAD_RECORDS: ` ${API}API/epaper/records/downloadFile`,
    FAX_RESEND: `${API}API/epaper/fax/resend`,
    FACILITY_EMR_LIST: `${API}API/epaper/employee/get/facility/emrsettinglist`,
    FINALCOST_FOR_VIEW: `${API}API/epaper/records/finalCostForView`
  }
};
export default configUrl;
